import _get from 'lodash/get';

export const getGdprNoticeVisibility = state => _get(state, 'gdpr.isGdprNoticeVisible');

export const getGdprNoticeDuration = state => _get(state, 'gdpr.gdprNoticeDuration');
